<template lang="pug">
  - $image_path = '@/assets/images/game/apply/';
  .view-apply.present-type-view(ref="page" :class="`type-${presentType}`")
    .inner
      .page-title
        p.page-title-text(ref="title"): img(:src="getTypeImage('present', 'title.png')")
        .page-title-decoration-white(ref="titleDecoration"): img(:src="getTypeImage('present', 'title_decoration_white.png')")
        .page-title-decoration-yellow(ref="titleDecoration"): img(:src="getTypeImage('present', 'title_decoration_yellow.png')")
      .board
        p.board-text: img(:src="getTypeImage('apply', 'text_apply.png')")
        .board-present: img(:src="getTypeImage('apply', 'image_present.png')")
        .board-charactor: img(:src="getTypeImage('apply', 'image_charactor.png')")
        .board-frame: img(src=`${$image_path}image_frame.png`)
      .howto
        a.howto-button.howto-follow(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener")
          img(src=`${$image_path}button_follow.png` alt="Twitterをフォローする")
        a.howto-button.howto-apply(:href="twitterShareText" target="_blank" rel="noopener" @click="share")
          img(src=`${$image_path}button_apply.png` alt="ツイートして応募")
        p: img(:src="getTypeImage('apply', 'text_howto.png')" alt="応募方法")
      p.present: img(src=`${$image_path}text_present_list.png`)
      .important
        h2.important-title: img(src=`${$image_path}title_important.png` alt="応募要項")
        p.important-text 以下をご一読の上、ご応募ください。
        ul.important-list
          li
            button.important-list-action(@click="isShowImportant = !isShowImportant")
              img(src=`${$image_path}button_important.png` alt="応募要項")
            .important-list-textarea.section-textarea(v-if="isShowImportant")
              p.textarea-text.textarea-break 以下をご一読の上、ご応募ください。
              p.textarea-subtitle ●キャンペーン応募期間
              .textarea-nest.textarea-break
                p.textarea-text 2020年5月12日(火)～2020年5月31日(日)23:59
              p.textarea-subtitle ●賞品・当選人数
              .textarea-nest.textarea-break
                p.textarea-text 抽選で合計2020名様に以下の賞品が当たります。
                p.textarea-text.textarea-indent ・【超ハッピーターン賞】：GARMINスマートウォッチ (VENU Black / Slate)：3名様
                p.textarea-text.textarea-indent ・【やっターン賞】：108gハッピーターン　1ケース(12袋入)：1500名様
                p.textarea-text.textarea-indent ・【とっターン賞】：Amazonギフト券500円分：517名様
              p.textarea-subtitle ●応募方法
              .textarea-nest.textarea-break
                p.textarea-text スマホゲーム「走れ！ターン王子」をプレイし、ハートの数に気をつけながらゴールを目指します。ゴールした際に獲得した点数によってアクセスできる各賞の応募画面から、「ツイートして応募」ボタンを押して、自動で入力されたツイート文を投稿し、ご応募ください。その際、ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」のフォローが必要となります。
                p.textarea-text 2020年5月31日23:59までのTwitter投稿をもって、応募完了といたします。
                p.textarea-text.textarea-indent ※ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」をフォローしなくてもゲームで遊べます。
                p.textarea-text.textarea-indent ※本ゲームはスマートフォン専用ゲームとなります。パソコンでのゲームプレイは出来ません。
                p.textarea-text.textarea-indent ※獲得点数を書き換えての応募（投稿）は、無効となります。
                p.textarea-text.textarea-indent ※本キャンペーンへのご応募は、期間中お一人様何度でも可能です。
                p.textarea-text.textarea-indent ※お客様がお使いいただく端末によっては、動作に不具合が生じる場合がございます。また、正常に投稿完了されなかった場合、抽選対象外とさせていただく場合がございます。動作保証端末ページをご確認ください。
                p.textarea-text.textarea-indent ※下記の方法で投稿された場合、参加とみなされない場合がございます。
                .textarea-nest
                  p.textarea-text.textarea-indent ・他人の投稿のテキストを改変し、投稿した場合
                  p.textarea-text.textarea-indent ・Twitter社以外の第三者が作成したアプリやツールを介してリツイートを実施した場合
                  p.textarea-text.textarea-indent ・ご応募の際、ご自身のTwitterアカウントを非公開設定にしている場合またはご応募後にハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」のフォローを解除した場合
              p.textarea-subtitle ●当選発表
              .textarea-nest.textarea-break
                p.textarea-text.textarea-indent ・キャンペーン期間終了後、厳正なる抽選の上で当選者を決定いたします。
                p.textarea-text.textarea-indent ・当選は1アカウント1回とさせていただきます。
                p.textarea-text.textarea-indent ・結果発表は当選者にTwitterのダイレクトメッセージでご連絡いたします。
                p.textarea-text.textarea-indent ・通信障害等によりダイレクトメッセージを受信できなかった場合でも亀田製菓は責任を負いかねますので、あらかじめご了承下さい。
                p.textarea-text.textarea-indent ・Amazonギフト券は、ギフト券番号をTwitterのダイレクトメッセージにて送付いたします。
                .textarea-nest
                  p.textarea-text.textarea-indent ※ハッピーターン公式Twitterアカウントよりご連絡いたしますので、メッセージを受信できるよう設定してください。
                  p.textarea-text.textarea-indent ※ご応募の際、非公開設定をONにされている方は、抽選対象外になりますのでご注意ください。
                  p.textarea-text.textarea-indent ※ご応募後にハッピーターン公式Twitterアカウントのフォローを解除した場合は、抽選対象外になりますのでご注意ください。
                  p.textarea-text.textarea-indent ※ダイレクトメッセージの再送・Amazonギフト券番号の再発行はいたしません。
                p.textarea-text.textarea-indent ・当選者への通知は、2020年6月上旬頃を予定しています。
              p.textarea-subtitle ●応募資格
              .textarea-nest
                p.textarea-text.textarea-indent ・本応募要項、利用規約に同意していただいた方
                p.textarea-text.textarea-indent.textarea-break ・未成年者の方は保護者の同意を得た上でご応募ください。未成年者からの応募があった場合、保護者の同意を得たものとみなします。
                p.textarea-text 同意なく応募され何らかの被害や問題が生じた場合、亀田製菓株式会社（以下「当社」といいます）及び「走れ！ターン王子」事務局（以下「事務局」といいます）では一切責任を負いません。
                p.textarea-text.textarea-indent ・Twitterのアカウントをお持ちの方
                .textarea-nest
                  p.textarea-text.textarea-indent
                    | ※Twitterアカウントをお持ちでない方は下記サイトより新規登録をしてください。
                    br
                    | #[a(href="https://twitter.com") https://twitter.com]
                p.textarea-text.textarea-indent ・ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」をフォローしている方
                p.textarea-text.textarea-indent ・スマホゲーム「走れ！ターン王子」をプレイし、ゴールした際にアクセスできる各賞の応募画面から、自動で入力されたツイート文のまま投稿した方
                p.textarea-text.textarea-indent ・日本国内にお住まいの方、かつ賞品のお届けが日本国内の方。
                .textarea-nest
                  p.textarea-text.textarea-indent ※亀田製菓社員および関係者は応募できません。
          li
            button.important-list-action(@click="isShowTerms = !isShowTerms")
              img(src=`${$image_path}button_terms.png` alt="利用規約")
            .important-list-textarea.section-textarea(v-if="isShowTerms")
              p.textarea-text.textarea-indent ●応募が完了した時点で、本利用規約の全てにご同意いただいたものとみなします。
              p.textarea-text.textarea-indent ●本利用規約に記載のない事項については、当社及び事務局が最終的な決定権を持つものとします。
              p.textarea-text.textarea-indent ●本キャンペーンのご当選者は、同時期に実施されている当社の他の消費者キャンペーンとは重複してご当選できない場合がございます。
              p.textarea-text.textarea-indent ●ご応募は日本国内にお住まいの方で、かつ賞品のお届けが日本国内の方に限らせていただきます。
              p.textarea-text.textarea-indent ●応募者様本人の都合により当選の連絡ができない場合は当選を無効とさせていただきます。
              p.textarea-text.textarea-indent ●応募後にハッピーターン公式Twitterアカウントのフォローを外されている場合、ユーザーIDを変更された場合、アカウント名が変更された場合、Twitterを退会されていた場合は抽選対象外となり、当選されていた場合も無効となりますのでご注意ください。
              p.textarea-text.textarea-indent ●当社社員及びそのご家族、関係者の応募はできません。
              p.textarea-text.textarea-indent ●当選権利の他人への譲渡や換金、他の賞品との引き換えはできません。
              p.textarea-text.textarea-indent ●ご当選者の住所、転居先が不明または長期不在などの理由により賞品がお届けできない際には、当選を取り消しさせていただく場合がございます。
              p.textarea-text.textarea-indent ●賞品は、予期せぬ事由などにより、予告なく変更する場合がございます。
              p.textarea-text.textarea-indent ●ご応募後の、受付確認、当選の有無などのお問い合わせにはお答えできません。
              p.textarea-text.textarea-indent ●ご応募いただいた投稿や画像の削除、変更及び応募の取消はキャンペーン事務局ではお受けできません。
              p.textarea-text.textarea-indent.textarea-break  ●ご投稿いただいた画像を亀田製菓のサイトやSNSアカウント、もしくは雑誌などのメディアに掲載する場合がございます。なおご応募いいただいた画像に関する著作権（著作権法第27条、第28条の権利を含みます）その他の知的財産権は当社に帰属するものとします。また掲載時には個別にお知らせすることはございませんので、予めご了承のうえ、ご応募ください。

              p.textarea-text.textarea-indent ●本キャンペーンはTwitter社とは一切関係ありません。
              p.textarea-text.textarea-indent ●当社及び事務局は、予告なく本キャンペーンの内容を変更することができるものとします。
              p.textarea-text.textarea-indent ●当社及び事務局は、ネットワークの不具合、コンピューターウイルスの影響及びサーバーへの不正アクセスなど、当社及び事務局の支配の及ばない理由により、本キャンペーンの円滑な運営、安全性、公正性等が損なわれると判断したときは、予告なく本キャンペーンを終了もしくはルールを変更することができるものとし、それに関連して生じた参加者の損害等について、一切責任を負いません。
              p.textarea-text.textarea-indent ●本キャンペーンへの応募に関連して参加者又は第三者が何らかの損害を被った場合であっても、当社及び事務局は、一切責任を負いません。利用者が本キャンペーンに関連するあらゆるWebサイトを利用する場合、当社及び事務局は、本キャンペーンに関連するあらゆるWebサイトに掲載される情報の正確性、合法性、道徳性、最新性、適切性などについて保証することはできません。
              p.textarea-text.textarea-indent ●本キャンペーンの応募にあたり、以下の行為のいずれかに該当、又は当社若しくは事務局が該当すると判断する行為をした場合は、当社若しくは事務局の判断で応募を無効とする、又は損害賠償を請求することがございます。

              .textarea-nest
                p.textarea-text.textarea-indent ○法令に違反する行為
                p.textarea-text.textarea-indent ○犯罪に関連する行為・公序良俗に反する行為
                p.textarea-text.textarea-indent ○賞品をキャンペーンの目的とは異なる方法（転売、非難目的を含みます）で使用する行為

              p.textarea-text.textarea-indent ●当社及び事務局は、本キャンペーンに関連するあらゆるWebサイトを利用したこと、又は利用ができないこと、本キャンペーンに関連するあらゆるWebサイトからのリンク先を利用したこと、又は利用ができないことによって引き起こされた損害について、直接的又は間接的な損害を問わず一切責任を負わないものとします。
              p.textarea-text.textarea-indent ●ご応募に発生するTwitterアプリ・キャンペーンサイトへの接続料や通信料はお客様ご自身の負担となります。
              p.textarea-text.textarea-indent ●キャンペーンに関するお問い合わせは、「走れ！ターン王子」キャンペーン事務局までお願いいたします。
              p.textarea-text.textarea-indent ●本キャンペーンについてのお問い合わせはAmazonではお受けしておりません。
              p.textarea-text.textarea-indent ●Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.またはその関連会社の商標です。

          li
            button.important-list-action(@click="isShowPolicy = !isShowPolicy")
              img(src=`${$image_path}buton_policy.png` alt="個人情報の取り扱いについて")
            .important-list-textarea.section-textarea(v-if="isShowPolicy")
              p.textarea-text.textarea-indent ※ご記入いただいた個人情報は、当選者の連絡及び賞品の発送と個人を特定しない統計情報として使用させていただき、お客様の同意なしに業務委託先以外の第三者に開示、提供することは一切ございません。(法令等により開示を求められた場合を除く)なお、いただいた個人情報は当社グループの個人情報保護方針に基づき安全かつ適切に管理いたします。詳しくは当社ホームページにて、『#[a(href="https://www.kamedaseika.co.jp/cs/?p=policy.policyIndex" target="_blank" rel="noopener") プライバシーポリシー]』をご確認ください。

        .important-contact
          p.important-contact-title
            span: img(src=`${$image_path}text_contact.png` alt="お問い合わせ先")
          .important-contact-textarea.section-textarea
            p.textarea-text 「走れ！ターン王子」キャンペーン事務局
            p.textarea-text 電話番号：0120-978-463
            p.textarea-text メール：info@kameda-cp.com
            p.textarea-text 事務局開設期間：2020年6月30日（火）まで受付（10:00～17:00　土・日・祝日を除く）
        .top(ref="top")
          router-link(:to="{ name:'top' }" @click.native="playSound('se_click_button')")
            img(src=`${$image_path}button_top.png` alt="トップ画面へ")
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap';
import { mapGetters } from 'vuex';

import CookieData from '@/assets/js/CookieData';
import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';

export default {
  name: 'Apply',
  data() {
    return {
      isShowImportant: false,
      isShowTerms: false,
      isShowPolicy: false
    };
  },
  computed: {
    ...mapGetters(['totalScore', 'presentType', 'rank']),
    twitterShareText() {
      if (this.presentType === 'l') {
        if (this.rank === 'gold') return this.twitterShareTextLGold;
        if (this.rank === 'silver') return this.twitterShareTextLSilver;
        return this.twitterShareTextLBronze;
      }
      if (this.presentType === 'm') return this.twitterShareTextM;
      return this.twitterShareTextS;
    },
    twitterShareTextLGold() {
      const uuid = Utils.getUniqueID();
      return Utils.getTwitterUrl({
        url: '　',
        text: `出ました、大記録${
          this.totalScore
        }点！完走して、みんなの笑顔を取り戻そう！\n#超ハッピーターン賞 #走れターン王子 #ハッピーターン #亀田製菓\nhttps://www.happyturn.com/run-campaign/2020/hashire-turn-ouji/gold/?id=${uuid}`
      });
    },
    twitterShareTextLSilver() {
      const uuid = Utils.getUniqueID();
      return Utils.getTwitterUrl({
        url: '　',
        text: `すごい記録だ、${
          this.totalScore
        }点！完走して、みんなの笑顔を取り戻そう！\n#超ハッピーターン賞 #走れターン王子 #ハッピーターン #亀田製菓\nhttps://www.happyturn.com/run-campaign/2020/hashire-turn-ouji/silver/?id=${uuid}`
      });
    },
    twitterShareTextLBronze() {
      const uuid = Utils.getUniqueID();
      return Utils.getTwitterUrl({
        url: '　',
        text: `今回の記録、なんと${
          this.totalScore
        }点！完走して、みんなの笑顔を取り戻そう！\n#超ハッピーターン賞 #走れターン王子 #ハッピーターン #亀田製菓\nhttps://www.happyturn.com/run-campaign/2020/hashire-turn-ouji/bronze/?id=${uuid}`
      });
    },
    twitterShareTextM() {
      const uuid = Utils.getUniqueID();
      return Utils.getTwitterUrl({
        url: '　',
        text: `今回の記録は${
          this.totalScore
        }点、やっターン！完走して、みんなの笑顔を取り戻そう！\n#やっターン賞  #走れターン王子 #ハッピーターン #亀田製菓\nhttps://www.happyturn.com/run-campaign/2020/hashire-turn-ouji/m/?id=${uuid}`
      });
    },
    twitterShareTextS() {
      const uuid = Utils.getUniqueID();
      return Utils.getTwitterUrl({
        url: '　',
        text: `今回の記録は${
          this.totalScore
        }点だっターン！完走して、みんなの笑顔を取り戻そう！\n#とっターン賞 #走れターン王子 #ハッピーターン #亀田製菓\nhttps://www.happyturn.com/run-campaign/2020/hashire-turn-ouji/s/?id=${uuid}`
      });
    }
  },
  beforeDestroy() {
    SoundController.stopAll();
  },
  methods: {
    getTypeImage(key, filename) {
      return require(`@/assets/images/game/${key}/${
        this.presentType
      }/${filename}`);
    },
    share() {
      CookieData.setIsShare(true);

      let presentType = '';
      if (this.presentType === 'l') {
        presentType = 'Bronze';
        if (this.rank === 'gold') presentType = 'Gold';
        if (this.rank === 'silver') presentType = 'Silver';
      }
      if (this.presentType === 'm') presentType = 'M';
      if (this.presentType === 's') presentType = 'S';
      Utils.tracking(`tweetApply${presentType}Btn`);
    },
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.view-apply {
  position: relative;
  width: 100%;
  @include present-type-image;
  &.type-s {
    .board {
      &-present {
        top: vw(140);
        left: vw(132);
        width: vw(705);
      }
      &-charactor {
        top: vw(63);
        right: vw(-88);
        width: vw(385);
      }
      &-text {
        bottom: vw(60);
        left: vw(47);
        width: vw(1104);
      }
    }
  }
  &.type-m {
    .board {
      &-present {
        top: vw(-20);
        left: vw(395);
        width: vw(394);
      }
      &-charactor {
        top: vw(64);
        left: vw(-92);
        width: vw(499);
      }
      &-text {
        bottom: vw(33);
        left: vw(65);
        width: vw(1061);
      }
    }
  }
  &.type-l {
    .board {
      &-present {
        top: vw(-15);
        left: vw(356);
        width: vw(777);
      }
      &-charactor {
        top: vw(64);
        left: vw(-115);
        width: vw(562);
      }
      &-text {
        bottom: vw(60);
        left: vw(250);
        width: vw(689);
      }
    }
  }
}
.inner {
  position: relative;
  overflow: hidden;
  padding-top: vw(365);
}
.board {
  position: relative;
  width: vw(1198);
  margin: 0 auto vw(24);
  &-present {
    position: absolute;
  }
  &-charactor {
    position: absolute;
  }
  &-text {
    position: absolute;
    z-index: 1;
  }
}
.howto {
  position: relative;
  margin-bottom: vw(60);
  &-button {
    display: block;
    position: absolute;
    left: vw(240);
    width: vw(800);
  }
  &-follow {
    top: vw(376);
  }
  &-apply {
    top: vw(716);
  }
}
.important {
  padding: vw(105) 0 vw(95);
  background-color: #fff100;
  text-align: center;
  &-title {
    width: vw(277);
    margin: 0 auto vw(65);
  }
  &-text {
    margin-bottom: vw(70);
    font-size: vw(46);
    font-weight: bold;
  }
  &-list {
    margin-bottom: vw(60);
    li {
      width: vw(1080);
      margin: 0 auto vw(40);
      &:last-child {
        margin-bottom: 0;
      }
      .important-list-action {
        position: relative;
        margin-bottom: vw(40);
        &::before {
          display: block;
          content: '';
          position: absolute;
          top: vw(80);
          right: vw(80);
          width: vw(59);
          height: vw(36);
          background-image: image-url('game/apply/image_arrow.png');
          background-size: 100% auto;
        }
      }
      .important-list-textarea {
        padding: vw(70);
        background-color: #fff;
        text-align: left;
      }
    }
  }
  &-contact {
    overflow: hidden;
    width: vw(1080);
    margin: 0 auto vw(60);
    border-radius: vw(45);
    &-title {
      padding: vw(70) 0;
      background-color: #ff6a13;
      text-align: center;
      span {
        display: block;
        width: vw(419);
        margin: 0 auto;
      }
    }
    &-textarea {
      padding: vw(70);
      background-color: #fff;
      text-align: left;
    }
  }
  .section-textarea {
    .textarea-title {
      font-size: vw(36);
      font-weight: bold;
    }
    .textarea-subtitle {
      font-size: vw(36);
      font-weight: bold;
    }
    .textarea-text {
      font-size: vw(36);
      line-height: 1.4;
    }
    .textarea-nest {
      padding-left: vw(36);
    }
    .textarea-indent {
      padding-left: 1em;
      text-indent: -1em;
    }
    .textarea-break {
      margin-bottom: vw(16);
    }
    a {
      text-decoration: underline;
    }
  }
  .top {
    width: vw(816);
    margin: 0 auto;
    a {
      display: block;
    }
  }
}
</style>
